import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

// Get base URL from environment variable
// const baseURL = process.env.REACT_APP_API_BASE_URL;
const baseURL = "https://securelab.api.sehhasolutions.com/api/";
// const baseURL = "https://localhost:44397/api/";



const api = axios.create({
  baseURL,
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  }
});

// Check if token is expired
const isTokenExpired = () => {
  const token = sessionStorage.getItem('token');
  if (!token) return true;
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now();
    return currentTime >= decodedToken.exp * 1000;
  } catch {
    return true;
  }
};

// Logout function
const logout = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('refreshToken');
  localStorage.clear();
  window.location.href = '/';
};

// Request interceptor
api.interceptors.request.use(
  (config) => {
    if (isTokenExpired()) {
      logout();
      return Promise.reject('Token expired');
    }

    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
